import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import TemplatesPage from "@/pages/templates/page";
import TutorialPage from "@/pages/tutorial/page";
import SafetyPage from "@/pages/safety/page";
import ComparisonPage from "@/pages/comparison/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/superbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/superbuy-spreadsheet-templates",
    element: <TemplatesPage />,
  },
  {
    path: "/superbuy-spreadsheet-tutorial",
    element: <TutorialPage />,
  },
  {
    path: "/superbuy-spreadsheet-safety",
    element: <SafetyPage />,
  },
  {
    path: "/superbuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;